// PEW1 — Modal cotización: 2 servicios, calculadoras CLP, envío contacto
(() => {
  const modal = document.querySelector('[data-pew-quote-modal]');
  if (!modal) return;

  const CL_OPEN = 'is-open';
  const CL_ACTIVE = 'is-active';
  const SLIDE_COUNT = 2;
  const WA_NUMBER = (window.PEW1_THEME && window.PEW1_THEME.whatsappNumber) || '+56935733021';

  const muralForm = modal.querySelector('#ContactForm-PewMural');
  const canvasForm = modal.querySelector('#ContactForm-PewCanvas');
  const mainPanel = modal.querySelector('[data-pew-quote-main]');
  const successPanel = modal.querySelector('[data-pew-quote-success]');
  const successIdEl = modal.querySelector('[data-pew-quote-success-id]');
  const successSummaryEl = modal.querySelector('[data-pew-quote-success-summary]');
  const slides = modal.querySelectorAll('[data-pew-quote-slide]');
  const tabs = modal.querySelectorAll('[data-pew-quote-slide-tab]');
  const dots = modal.querySelectorAll('[data-pew-quote-dot]');
  const fileBuckets = { mural: [], canvas: [] };

  const MURAL = {
    basicMin: 30000, basicMax: 50000, complexMin: 50000, complexMax: 150000,
    get basicMid() { return (this.basicMin + this.basicMax) / 2; },
    get complexMid() { return (this.complexMin + this.complexMax) / 2; },
  };
  const CANVAS = { simplePerCm2: 1000, complexPerCm2: 2500 };

  let activeSlide = 0;
  let lastFocus = null;

  function formatClp(value) {
    const n = Math.round(Number(value) || 0);
    try {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(n);
    } catch {
      return `$${n.toLocaleString('es-CL')}`;
    }
  }

  function heightStepFactor(h) {
    if (h <= 3) return 1.0;
    if (h <= 5) return 1.3;
    if (h <= 8) return 1.6;
    return 2.0;
  }

  function heightExponentialFactor(h) {
    if (h <= 3) return 1;
    return Math.min(2.2, Math.pow(h / 3, 0.55));
  }

  function generateQuoteId() {
    const d = new Date();
    const rnd = String(Math.floor(Math.random() * 1000)).padStart(3, '0');
    return `COT-${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}-${rnd}`;
  }

  function getFocusable(container) {
    return container.querySelectorAll('a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
  }

  function trapFocus(e) {
    if (e.key !== 'Tab' || !modal.classList.contains(CL_OPEN)) return;
    const focusables = getFocusable(modal);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }

  function openModal() {
    if (modal.classList.contains(CL_OPEN)) return;
    lastFocus = document.activeElement;
    modal.classList.add(CL_OPEN);
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('pew-modal-open');
    successPanel.hidden = true;
    mainPanel.hidden = false;
    getFocusable(modal)[0]?.focus();
  }

  function closeModal() {
    if (!modal.classList.contains(CL_OPEN)) return;
    modal.classList.remove(CL_OPEN);
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('pew-modal-open');
    successPanel.hidden = true;
    mainPanel.hidden = false;
    lastFocus?.focus?.();
  }

  function setActiveSlide(index) {
    activeSlide = Math.max(0, Math.min(SLIDE_COUNT - 1, index));
    slides.forEach((el, i) => {
      const on = i === activeSlide;
      el.classList.toggle(CL_ACTIVE, on);
      el.hidden = !on;
    });
    tabs.forEach((btn, i) => {
      btn.classList.toggle(CL_ACTIVE, i === activeSlide);
      btn.setAttribute('aria-selected', i === activeSlide ? 'true' : 'false');
    });
    dots.forEach((dot, i) => dot.classList.toggle(CL_ACTIVE, i === activeSlide));
    modal.querySelectorAll('[data-pew-quote-prev]').forEach((btn) => { btn.disabled = activeSlide === 0; });
    modal.querySelectorAll('[data-pew-quote-next]').forEach((btn) => { btn.disabled = activeSlide === SLIDE_COUNT - 1; });
  }

  function updateMuralTableBases() {
    const b = modal.querySelector('[data-pew-mural-base-basic]');
    const c = modal.querySelector('[data-pew-mural-base-complex]');
    if (b) b.textContent = `${formatClp(MURAL.basicMid)} / m²`;
    if (c) c.textContent = `${formatClp(MURAL.complexMid)} / m²`;
  }

  function updateMuralPricing() {
    const design = modal.querySelector('[data-pew-mural-design]')?.value || '';
    const w = parseFloat(modal.querySelector('[data-pew-mural-width]')?.value || '0');
    const h = parseFloat(modal.querySelector('[data-pew-mural-height]')?.value || '0');
    const totalInput = modal.querySelector('[data-pew-mural-total]');
    const factorEl = modal.querySelector('[data-pew-mural-height-factor]');
    const areaEl = modal.querySelector('[data-pew-mural-area]');

    modal.querySelectorAll('[data-pew-mural-row]').forEach((row) => row.classList.remove('is-selected'));
    if (design.includes('Basico')) modal.querySelector('[data-pew-mural-row="basic"]')?.classList.add('is-selected');
    else if (design.includes('Complejo')) modal.querySelector('[data-pew-mural-row="complex"]')?.classList.add('is-selected');

    const area = w > 0 && h > 0 ? w * h : 0;
    if (areaEl) areaEl.textContent = area > 0 ? `${area.toFixed(2)} m²` : '0 m²';

    const combined = heightStepFactor(h || 0) * heightExponentialFactor(h || 0);
    if (factorEl) factorEl.textContent = `×${combined.toFixed(2).replace('.', ',')}`;

    let basePerM2 = design.includes('Complejo') ? MURAL.complexMid : design.includes('Basico') ? MURAL.basicMid : 0;
    const total = area > 0 && basePerM2 > 0 && h > 0 ? area * basePerM2 * combined : 0;
    if (totalInput) totalInput.value = total > 0 ? formatClp(total) : '—';
  }

  function updateCanvasPricing() {
    const design = modal.querySelector('[data-pew-canvas-design]')?.value || '';
    const w = parseFloat(modal.querySelector('[data-pew-canvas-width]')?.value || '0');
    const h = parseFloat(modal.querySelector('[data-pew-canvas-height]')?.value || '0');
    const totalInput = modal.querySelector('[data-pew-canvas-total]');
    const areaEl = modal.querySelector('[data-pew-canvas-area]');

    modal.querySelectorAll('[data-pew-canvas-row]').forEach((row) => row.classList.remove('is-selected'));
    if (design === 'Simple') modal.querySelector('[data-pew-canvas-row="simple"]')?.classList.add('is-selected');
    else if (design === 'Compleja') modal.querySelector('[data-pew-canvas-row="complex"]')?.classList.add('is-selected');

    const area = w > 0 && h > 0 ? w * h : 0;
    if (areaEl) areaEl.textContent = area > 0 ? `${Math.round(area)} cm²` : '0 cm²';

    const rate = design === 'Simple' ? CANVAS.simplePerCm2 : design === 'Compleja' ? CANVAS.complexPerCm2 : 0;
    const total = area > 0 && rate > 0 ? area * rate : 0;
    if (totalInput) totalInput.value = total > 0 ? formatClp(total) : '—';
  }

  async function buildAttachmentSection(bucket) {
    const files = fileBuckets[bucket];
    if (!files.length) return '(Sin archivos adjuntos)';
    const lines = [];
    for (const file of files) {
      lines.push(`- ${file.name} (${Math.round(file.size / 1024)} KB)`);
      if (file.size > 80000) lines.push(`  (Archivo grande: compartir por WhatsApp ${WA_NUMBER})`);
    }
    return lines.join('\n');
  }

  function renderFilePreview(bucket) {
    const input = modal.querySelector(`[data-pew-file-input="${bucket}"]`);
    const wrap = modal.querySelector(`[data-pew-file-preview="${bucket}"]`);
    if (!input || !wrap) return;
    wrap.innerHTML = '';
    fileBuckets[bucket].forEach((file) => {
      const item = document.createElement('div');
      item.className = 'pew-file-preview__item';
      if (file.type.startsWith('image/')) {
        const img = document.createElement('img');
        img.alt = file.name;
        img.src = URL.createObjectURL(file);
        img.className = 'pew-file-preview__thumb';
        item.appendChild(img);
      }
      const cap = document.createElement('span');
      cap.className = 'pew-file-preview__caption';
      cap.textContent = file.name;
      item.appendChild(cap);
      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'pew-file-preview__remove';
      removeBtn.textContent = 'Quitar';
      removeBtn.addEventListener('click', () => {
        fileBuckets[bucket] = fileBuckets[bucket].filter((f) => f !== file);
        const dt = new DataTransfer();
        fileBuckets[bucket].forEach((f) => dt.items.add(f));
        input.files = dt.files;
        renderFilePreview(bucket);
      });
      item.appendChild(removeBtn);
      wrap.appendChild(item);
    });
  }

  async function buildMuralBody(quoteId) {
    const get = (name) => muralForm.querySelector(`[name="${name}"]`)?.value?.trim() || '';
    const design = get('contact[Tipo diseno mural]');
    const w = parseFloat(get('contact[Mural ancho m]') || '0');
    const h = parseFloat(get('contact[Mural alto m]') || '0');
    const area = w * h;
    const combined = heightStepFactor(h) * heightExponentialFactor(h);
    const basePerM2 = design.includes('Complejo') ? MURAL.complexMid : MURAL.basicMid;
    const totalNum = area > 0 && h > 0 ? area * basePerM2 * combined : 0;
    const att = await buildAttachmentSection('mural');
    return [
      '=== COTIZACION PEW1 ===', `Numero: ${quoteId}`, 'Servicio: Servicio 01 - Mural artistico', '',
      `Nombre: ${get('contact[name]')}`, `Email: ${get('contact[email]')}`, `Telefono: ${get('contact[phone]')}`,
      `Ciudad / Pais: ${get('contact[Ciudad pais]')}`, `Tipo de diseno: ${design}`,
      `Dimensiones: ${w} m x ${h} m`, `Area: ${area.toFixed(2)} m2`, `Factor altura: ${combined.toFixed(3)}`,
      `Superficie: ${get('contact[Superficie material]')}`, `Fecha: ${get('contact[Fecha estimada mural]')}`,
      `Presupuesto estimado: ${totalNum > 0 ? formatClp(totalNum) : 'N/D'}`, '', `Descripcion:`, get('contact[Descripcion mural]'), '', `Archivos:`, att,
    ].join('\n');
  }

  async function buildCanvasBody(quoteId) {
    const get = (name) => canvasForm.querySelector(`[name="${name}"]`)?.value?.trim() || '';
    const design = get('contact[Tipo obra tela]');
    const w = parseFloat(get('contact[Tela ancho cm]') || '0');
    const h = parseFloat(get('contact[Tela alto cm]') || '0');
    const area = w * h;
    const rate = design === 'Compleja' ? CANVAS.complexPerCm2 : CANVAS.simplePerCm2;
    const totalNum = area > 0 && (design === 'Simple' || design === 'Compleja') ? area * rate : 0;
    const att = await buildAttachmentSection('canvas');
    return [
      '=== COTIZACION PEW1 ===', `Numero: ${quoteId}`, 'Servicio: Servicio 02 - Pintura original en tela', '',
      `Nombre: ${get('contact[name]')}`, `Email: ${get('contact[email]')}`, `Telefono: ${get('contact[phone]')}`,
      `Ciudad / Pais: ${get('contact[Ciudad pais]')}`, `Tipo de obra: ${design}`,
      `Dimensiones: ${w} cm x ${h} cm`, `Area: ${Math.round(area)} cm2`,
      `Precio estimado: ${totalNum > 0 ? formatClp(totalNum) : 'N/D'}`, '',
      `Descripcion:`, get('contact[Descripcion obra tela]'),
      `Destino: ${get('contact[Destino obra]')}`, `Fecha entrega: ${get('contact[Fecha entrega deseada]')}`, '', `Archivos:`, att,
    ].join('\n');
  }

  function showSuccess(quoteId, summaryHtml) {
    successIdEl.textContent = quoteId;
    successSummaryEl.innerHTML = summaryHtml;
    mainPanel.hidden = true;
    successPanel.hidden = false;
    successPanel.querySelector('[data-pew-quote-close]')?.focus();
  }

  async function handleSubmit(e, form, kind) {
    e.preventDefault();
    const errEl = form.querySelector('[data-pew-quote-error]');
    const submitBtn = form.querySelector('[type="submit"]');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }

    const quoteId = generateQuoteId();
    form.querySelector('[data-pew-quote-id-input]').value = quoteId;

    const bodyField = kind === 'mural' ? form.querySelector('[data-pew-mural-body]') : form.querySelector('[data-pew-canvas-body]');
    const bodyText = kind === 'mural' ? await buildMuralBody(quoteId) : await buildCanvasBody(quoteId);
    if (bodyField) bodyField.value = bodyText;

    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Enviando…'; }

    try {
      const contactUrl = modal.getAttribute('data-contact-url') || '/contact';
      const res = await fetch(contactUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error('submit failed');

      const servicio = kind === 'mural' ? 'Mural artístico' : 'Pintura original en tela';
      const precio = form.querySelector(kind === 'mural' ? '[data-pew-mural-total]' : '[data-pew-canvas-total]')?.value || '—';
      showSuccess(quoteId, `<p><strong>${servicio}</strong></p><p>Presupuesto referencial: ${precio}</p><p>Te contactaremos pronto al email indicado.</p>`);
      form.reset();
      fileBuckets[kind] = [];
      renderFilePreview(kind);
      updateMuralPricing();
      updateCanvasPricing();
    } catch {
      if (errEl) {
        errEl.textContent = `No se pudo enviar. Escríbenos por WhatsApp: ${WA_NUMBER}`;
        errEl.hidden = false;
      }
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = kind === 'mural' ? 'Enviar cotización mural' : 'Enviar cotización tela';
      }
    }
  }

  document.querySelectorAll('[data-pew-quote-open]').forEach((btn) => {
    btn.addEventListener('click', () => { openModal(); setActiveSlide(0); updateMuralPricing(); updateCanvasPricing(); });
  });
  modal.querySelectorAll('[data-pew-quote-close]').forEach((btn) => btn.addEventListener('click', closeModal));
  modal.querySelector('[data-pew-quote-backdrop]')?.addEventListener('click', closeModal);
  document.addEventListener('keydown', (e) => { if (modal.classList.contains(CL_OPEN) && e.key === 'Escape') closeModal(); trapFocus(e); });

  tabs.forEach((tab) => tab.addEventListener('click', () => setActiveSlide(parseInt(tab.getAttribute('data-pew-quote-slide-tab') || '0', 10))));
  dots.forEach((dot) => dot.addEventListener('click', () => setActiveSlide(parseInt(dot.getAttribute('data-pew-quote-dot') || '0', 10))));
  modal.querySelectorAll('[data-pew-quote-next]').forEach((btn) => btn.addEventListener('click', () => setActiveSlide(activeSlide + 1)));
  modal.querySelectorAll('[data-pew-quote-prev]').forEach((btn) => btn.addEventListener('click', () => setActiveSlide(activeSlide - 1)));

  modal.querySelectorAll('[data-pew-mural-design], [data-pew-mural-width], [data-pew-mural-height]').forEach((el) => {
    el.addEventListener('input', updateMuralPricing);
    el.addEventListener('change', updateMuralPricing);
  });
  modal.querySelectorAll('[data-pew-canvas-design], [data-pew-canvas-width], [data-pew-canvas-height]').forEach((el) => {
    el.addEventListener('input', updateCanvasPricing);
    el.addEventListener('change', updateCanvasPricing);
  });

  modal.querySelector('[data-pew-file-input="mural"]')?.addEventListener('change', (e) => {
    fileBuckets.mural = Array.from(e.target.files || []);
    renderFilePreview('mural');
  });
  modal.querySelector('[data-pew-file-input="canvas"]')?.addEventListener('change', (e) => {
    fileBuckets.canvas = Array.from(e.target.files || []);
    renderFilePreview('canvas');
  });

  muralForm?.addEventListener('submit', (e) => handleSubmit(e, muralForm, 'mural'));
  canvasForm?.addEventListener('submit', (e) => handleSubmit(e, canvasForm, 'canvas'));

  if (window.PEW1_THEME?.quoteAutoOpen) openModal();
  updateMuralTableBases();
  updateMuralPricing();
  updateCanvasPricing();
  setActiveSlide(0);
})();
